<template>
    <div class="staoDelVerify">
        <div class="staoDelHolder">
            <i id="closeDelVerify" class="material-icons" @click="closeDel">close</i>
            <form class="delForm">

                <p class="question">Are you sure about deleting {{staoInfo.name}}?</p>
                <input class="delInput" type="password" placeholder="password" v-model="pw">
                <button class="delButton" @click.prevent="deleteUser">del</button>
            </form>
        </div>
    </div>
</template>

<script>

export default {
    data () {
        return {
            id: 0,
            pw: ''
        }
    },
    computed: {
        staoInfo () {
            return this.$store.getters['user/staoInfo'];
        }

    },
    methods: {
        deleteUser () {
            this.$store.dispatch('user/delStao', { pw: this.pw,
                                                    id: this.staoInfo.id });
        },
        closeDel () {
            this.$router.go(-1);
        }

    }
}
</script>

<style scoped sass>

#closeDelVerify{
    position: absolute;
    top:0;
    right:0;
    cursor: pointer;
    font-size: 40px;
}

.staoDelVerify{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background-color: blue; */
    z-index: 900;

}

.staoDelHolder{
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    /*height: 200px;*/
    background-color: white;
    box-shadow: 0px 0px 60px grey;
    padding-top: 10px;
    padding-bottom: 10px;
}

.delForm{
    display:flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 20px;
    margin-right: 40px;
}

.delInput{
    font-size: 20px;

}

.question{
    font-size: 15px;
}

@media screen and (min-width: 500px){
    .staoDelHolder{
        width: 500px;
    }
    .question{
        font-size: 20px;
    }
}

@media screen and (min-width: 1300px){
    .staoDelHolder{
        width: 700px;
    }

    .delInput{
        font-size: 30px;

    }

    .delButton{
        font-size: 40px;
        min-height: 60px;
    }

    .question{
        font-size: 25px;
    }

}

</style>
